import React, {useContext, useEffect} from 'react'
import {PurchaseContext} from "../../../context/PurchaseContext";
import {Form, Input} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const TaxName = ({record, rowIndex}) => {
    const [form] = Form.useForm()
    const {taxes} = useContext(PurchaseContext)
    const [taxList, setTaxList] = taxes

    useEffect(() => {
        form.setFieldsValue({taxName: record.taxName})
    }, [record])

    const handleNameChange = ({target: {value}}) => {
        const newList = replaceIndexAt(
            taxList,
            {
                ...taxList[rowIndex],
                taxName: value
            },
            rowIndex
        )
        setTaxList(newList)
    }

    return(
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={'taxName'}>
                    <Input onBlur={handleNameChange} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default TaxName